
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.44.5C5.485.5 3.75 2.062 3.75 5.62v3.13H0v3.75h3.75v9H7.5v-9h3l.75-3.75H7.5V6.254c0-1.34.437-2.004 1.695-2.004h2.055V.654C10.895.606 9.859.5 8.44.5z","fill":"#2196F3"}})])
          )
        }
      }
    